module.exports = __webpack_public_path__ + "img/Hailsham-and-Beyond.7dd79ab5.jpg";